import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterTamboerskloof() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-tamboerskloof",
    name: "Painters Tamboerskloof",
    location: "Tamboerskloof, Cape Town",
    rating: 4.8,
    reviews: 158,
    specialties: ["Residential Painting", "Heritage Restoration", "Decorative Finishes", "Waterproofing"],
    image: "https://public.readdy.ai/ai/img_res/103caca495898f2537fe99d774629737.jpg",
    verified: true,
    yearsExperience: 13,
    website: "https://painterstamboerskloof.co.za/",
    email: "info@painterstamboerskloof.co.za",
    description: "Painters Tamboerskloof is your trusted painting contractor serving Tamboerskloof and the City Bowl area of Cape Town. With 13 years of experience, we specialize in residential painting for this prestigious neighborhood's unique mix of heritage homes and modern properties. Our team understands the character and requirements of Tamboerskloof's diverse architecture, from Victorian cottages to contemporary hillside homes. We deliver exceptional results using premium materials and expert techniques, with particular expertise in heritage restoration and decorative finishes.",
    services: [
      "Interior House Painting",
      "Exterior House Painting",
      "Heritage Building Restoration",
      "Decorative Painting Finishes",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design",
      "Wall Preparation & Repairs",
      "Protective Coatings",
      "Maintenance Services"
    ],
    serviceAreas: ["Tamboerskloof", "Gardens", "Oranjezicht", "Higgovale", "City Bowl", "Vredehoek", "Bo-Kaap"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20Victorian%20living%20room%20interior%20painted%20by%20professional%20painters%20in%20Tamboerskloof%20Cape%20Town%2C%20elegant%20heritage%20home%20with%20fresh%20white%20walls%2C%20period%20features%2C%20quality%20paint%20finish%2C%20classic%20furniture%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work&width=400&height=300&seq=tamboerskloof-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20heritage%20house%20painting%20project%20in%20Tamboerskloof%20Cape%20Town%2C%20Victorian%20cottage%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20hillside%20setting%20with%20mountain%20views%2C%20well-maintained%20historic%20property&width=400&height=300&seq=tamboerskloof-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20hillside%20home%20painting%20in%20Tamboerskloof%20Cape%20Town%2C%20professional%20painters%20working%20on%20contemporary%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20stunning%20city%20and%20mountain%20views%2C%20organized%20work%20site&width=400&height=300&seq=tamboerskloof-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Elegant%20dining%20room%20interior%20painting%20in%20Tamboerskloof%20home%2C%20fresh%20painted%20walls%20with%20premium%20finish%2C%20sophisticated%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=tamboerskloof-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Heritage%20building%20restoration%20painting%20in%20Tamboerskloof%20Cape%20Town%2C%20professional%20painters%20working%20on%20historic%20property%2C%20quality%20restoration%20paint%20finish%2C%20period%20architecture%2C%20organized%20professional%20work%20site&width=400&height=300&seq=tamboerskloof-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Contemporary%20bedroom%20interior%20painting%20in%20Tamboerskloof%20home%2C%20fresh%20painted%20walls%20with%20quality%20finish%2C%20modern%20elegant%20design%2C%20bright%20natural%20lighting%2C%20professional%20painting%20work&width=400&height=300&seq=tamboerskloof-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Catherine Williams",
        rating: 5,
        comment: "Exceptional work on our Victorian home in Tamboerskloof! The team was incredibly respectful of the heritage features and delivered beautiful results. Professional service and excellent attention to detail throughout."
      },
      {
        name: "Robert Anderson", 
        rating: 5,
        comment: "Highly recommend Painters Tamboerskloof for any painting project. They painted our hillside home and handled the challenging access expertly. Quality workmanship and great communication from start to finish."
      },
      {
        name: "Sarah de Villiers",
        rating: 4,
        comment: "Very professional team that takes pride in their work. They painted our entire home including decorative finishes. Clean, efficient, and the results are stunning. Will definitely use them again."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Tamboerskloof | Professional Painting Services Cape Town | Heritage Restoration Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Tamboerskloof offers professional painting services for residential properties in Tamboerskloof, Cape Town. Specializing in heritage restoration, decorative finishes, and quality residential painting. 13+ years experience. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Tamboerskloof, house painters Tamboerskloof, painting contractors Cape Town, heritage restoration, residential painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20elegant%20home%20in%20Tamboerskloof%20Cape%20Town%2C%20prestigious%20hillside%20neighborhood%20with%20stunning%20Table%20Mountain%20views%20and%20city%20panorama%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20Victorian%20and%20contemporary%20architecture%2C%20bright%20natural%20lighting%2C%20high%20quality%20residential%20painting%20project&width=1200&height=600&seq=tamboerskloof-painters-hero-main&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Tamboerskloof</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Prestigious Neighborhood Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Tamboerskloof is one of Cape Town's most desirable residential areas, nestled on the slopes of Table Mountain with stunning views over the city and harbor. This prestigious neighborhood features a beautiful mix of Victorian and Edwardian heritage homes alongside contemporary hillside properties. Our team has extensive experience working in this area, understanding both the architectural significance of heritage buildings and the modern requirements of contemporary homes.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Heritage Restoration Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Many of Tamboerskloof's homes have significant historical value, requiring specialized restoration techniques and materials. Our team is experienced in heritage restoration work, understanding how to preserve original features, work with period moldings and decorative elements, and use appropriate materials that maintain architectural integrity. We take special care with historic surfaces, ensuring that restoration work enhances the building's character while providing modern protection and durability.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Decorative Finishes & Design</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Tamboerskloof's premium properties often require sophisticated decorative finishes and expert color consultation. Our team is skilled in various decorative painting techniques, from traditional finishes that complement heritage features to contemporary effects for modern homes. We work closely with homeowners, interior designers, and architects to achieve the perfect aesthetic, whether you're seeking period-appropriate colors for a Victorian cottage or contemporary palettes for a modern hillside home.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Hillside Property Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  Painting hillside properties in Tamboerskloof presents unique challenges, from access considerations to weather exposure. Our team is experienced in working on sloped sites, managing logistics efficiently, and ensuring safety throughout the project. We also understand the importance of waterproofing and weather protection for hillside homes, offering comprehensive solutions that protect your property from the elements while maintaining its beauty.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20elegant%20home%20in%20Tamboerskloof%20Cape%20Town%2C%20hillside%20property%20with%20mountain%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20Victorian%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=tamboerskloof-sidebar-image&orientation=landscape"
                      alt="Professional painters Tamboerskloof residential house painting services Cape Town heritage restoration"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Tamboerskloof</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential Painting Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for Tamboerskloof's unique mix of heritage and contemporary properties. From Victorian cottages to modern hillside homes, we provide comprehensive solutions that enhance aesthetics and protect your valuable property investment.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} with premium materials and expert application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Transform your Tamboerskloof home with our professional interior painting services. We use premium, low-VOC paints that are safe for your family while providing excellent coverage and durability. For heritage homes, we can match period-appropriate colors and finishes. For contemporary properties, we offer modern palettes and decorative techniques that enhance your home's unique character.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our color consultation services help you choose the perfect palette that complements your home's architecture and maximizes the stunning views that Tamboerskloof properties are known for. We work carefully to protect your furnishings and complete projects efficiently with minimal disruption.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior & Restoration Work</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Tamboerskloof requires expertise in both heritage restoration and modern applications. We use premium exterior paints that resist fading, weathering, and moisture damage. For heritage buildings, we employ specialized restoration techniques and appropriate materials that preserve architectural integrity while providing modern protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our comprehensive exterior services include waterproofing, damp proofing, and protective coatings—particularly important for hillside properties exposed to weather. We take special care with historic features and challenging access situations, ensuring beautiful, durable results that protect your investment.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Tamboerskloof</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Tamboerskloof and the City Bowl. Each project demonstrates our commitment to quality workmanship and our expertise in both heritage restoration and contemporary applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Tamboerskloof Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Tamboerskloof have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Tamboerskloof</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Tamboerskloof property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that enhance your home's unique character.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and City Bowl</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Tamboerskloof painting project. Our experienced team will assess your property and provide detailed recommendations tailored to your home's unique requirements.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
